import {List} from "@bonprix/design-system";
// @ts-ignore
import React, {FC, useEffect, useState} from 'react';
import {BenefitSection} from "./benefit-section";
import {BenefitSectionItem} from "./benefit-section-item";
import Landmark from "@core/scripts/components/landmark-adapter";
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from '../../components/message-list';

const BenefitSectionBox: FC<BenefitSection> = (benefitSection: BenefitSection) => {

    const [hideIfMissing, setHideIfMissing] = useState<Array<string>>(benefitSection.hideIfMissing);

    useEffect(() => {
        const subscription = MessageBroker.subscribe(ProductMessages.BENEFIT_ITEM_HIDE_IF_MISSING, ({attributes}) => setHideIfMissing(attributes));

        return () => MessageBroker.unsubscribe(subscription);
    }, []);

    const createBenefitSectionItem = (item: BenefitSectionItem, index: number): React.JSXElement => {
        const shouldHide = hideIfMissing.some((attribute: string) => item.hideIfMissing.includes(attribute));
        if (shouldHide) {
            return null;
        }

        return <List.Item key={index}
                          target={"_blank"}
                          onClick={()=>Landmark.sendClickLandmark('benefit'+(index+1))}
                          icon={item.icon}
                          href={item.link}>
            {item.text}
        </List.Item>
    };

    return (
        <List type="link"
              className="bg-clr-bg-light p-4"
              showArrows={false}>
            {benefitSection.items.map(createBenefitSectionItem)}
        </List>
    );
};

export default BenefitSectionBox;